export default {
  FETCH_PRIVACY_POLICY_REQUEST: 'FETCH_PRIVACY_POLICY_REQUEST',
  FETCH_PRIVACY_POLICY_SUCCESS: 'FETCH_PRIVACY_POLICY_SUCCESS',
  FETCH_PRIVACY_POLICY_FAILURE: 'FETCH_PRIVACY_POLICY_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/actions/privacy-policy.action-types.js